export default {
    GET_SELECT_SYNDICATOR:(state)=>{
        return state.selectSyndicator
    },
    GET_RESULT:(state)=>{
        return state.Result
    },
    GET_EDIT_SYNDICATOR:(state)=>{
        return state.editSyndicator
    },
}
